module.exports = __webpack_public_path__ + "img/02.f1d48d72.jpg";